import React, { FC } from 'react';

import lang from '../../../../lib/language';
import { FxOrder, FxOrderStatus } from '../../../../lib/models/reporting/types';
import { formatCurrencyBySymbol, getCurrencySymbolByCurrencyCode } from '../../../../lib/util/DataHelpers';
import { getFxFormattedDate } from '../../../../lib/util/DateTimeHelpers';
import { getFxOrderDateByStatus } from '../../../../lib/util/hooks/wallet/helpers';
import { TextHelpers } from '../../../../lib/util/TextHelpers';

import ArrowBack from '../../../../assets/img/blue_icon-arrow-left.svg';
import { Button, ClickableImage } from '../../../../components';
import { useIsMobile } from '../../../../hooks';

import styles from './FxOrderModal.module.scss';

type ModalInfoRowProps = {
  rowKey:string,
  rowValue?:string,
  rowValues?:string[],
}

const ModalInfoRow:FC<ModalInfoRowProps> = ({ rowKey, rowValue, rowValues }) => (
  <div className={styles.cardContent}>
    <span className={styles.cardKey}>{rowKey}</span>
    {rowValue && <span className={styles.cardValue}>{rowValue}</span>}
    {rowValues && (
    <div className={styles.cardValueWrapper}>
      {rowValues.map(item => (<span key={item} className={styles.cardValue}>{item}</span>))}
    </div>
    )}
  </div>
);
type Props = {
  handleModal: () => void;
    fxOrder: FxOrder;
}
const FxORderModal = ({ handleModal, fxOrder }: Props) => {
  const {
    boughtAmountCurr,
    boughtAmountValue,
    exchangeRate,
    orderStatus,
    soldAmountCurr,
    soldAmountValue,
    comissions,
  } = fxOrder;
  const isMobile = useIsMobile();
  const orderStatusText = TextHelpers.getFxOrderStatusNameLabel(orderStatus);
  const exchanged = `${formatCurrencyBySymbol(
    soldAmountValue,
    getCurrencySymbolByCurrencyCode(soldAmountCurr),
  )}`;
  return (
    <div className={styles.wrapperModal}>
      { isMobile && (
        <ClickableImage
          className={styles.returnArrow}
          src={ArrowBack}
          alt="Back"
          onClick={() => handleModal()}
        />
      )}
      <h6>
        { `+${formatCurrencyBySymbol(
          boughtAmountValue,
          getCurrencySymbolByCurrencyCode(boughtAmountCurr),
        )}` }
      </h6>
      <div className={styles.wrapperDate}>
        <span className={styles.date}>
          {getFxFormattedDate(getFxOrderDateByStatus(fxOrder))}
        </span>
        {orderStatus === FxOrderStatus.New && <span className={styles.statusPending}>{orderStatusText}</span>}
        {orderStatus === FxOrderStatus.Fill && <span className={styles.statusCompleted}>{orderStatusText}</span>}
        {orderStatus === FxOrderStatus.Rejected
          && <span className={styles.statusError}>{orderStatusText}</span>}
      </div>
      <div className={styles.wrapperCategoryDetails}>
        <div className={styles.containerDetails}>
          <ModalInfoRow rowKey={lang.mobileOrderDetailsType()} rowValue={TextHelpers.getFxOrderStatusName(fxOrder)} />
          <ModalInfoRow rowKey={lang.category()} rowValue={lang.walletCurrencyExchange()} />
          <ModalInfoRow rowKey={lang.walletExchanged()} rowValue={exchanged} />
          <ModalInfoRow rowKey={lang.rateHeader()} rowValue={`= ${exchangeRate}`} />
          <ModalInfoRow
            rowKey={comissions.length > 1 ? lang.fees() : lang.walletFee()}
            rowValues={comissions.map(
              item => formatCurrencyBySymbol(item.commValue, getCurrencySymbolByCurrencyCode(item.commCurr)),
            )}
          />
        </div>
      </div>
      { !isMobile && (
        <Button
          fullWidth
          id="closeModal"
          ariaLabel="close modal"
          className={styles.btnClose}
          onClick={() => handleModal()}
        >
            {lang.commonClose()}
        </Button>
      )}
    </div>
  );
};

export default FxORderModal;
